import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  HEIGHT_TOP_BAR,
  Z_INDEXS,
} from '../../themes'

export const StyleResetPassword = styled.div`
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: auto;
  width: 100%;
  color: ${COLOR.BLACK_1};
  position: relative;

  .container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 560px;
    margin: auto;
    height: ${({ confirmStatus }) => confirmStatus ? '100%' : 'unset'};
  }

  .top-bar {
    height: ${HEIGHT_TOP_BAR}px;
    background: ${COLOR.WHITE};
    position: absolute;
    z-index: ${Z_INDEXS.LV_2};
    width: 100%;

    > img {
      margin: 13px 0 0 16px;
    }
  }

  .title {
    margin-top: 145px;
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.XXL};
    text-align: center;
  }

  .sub_title {
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.TN};
    line-height: 25px;
    margin-bottom: 33px !important;
    margin-top: ${({ confirmStatus }) => confirmStatus ? '29px' : '10px'};
    text-align: center;
  }

  .data {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin: auto;
    margin-left: 30px;

    > div {
      > span {
        float: left;
        font-family: NunitoRegular;
        font-size: ${FONT_SIZE.XXS};
        margin-top: 18px;
      }
    }
  }

  .input-box {
    position: relative;
    width: 100%;

    input {
      width: 480px;
      height: 40px;
      background: ${COLOR.WHITE};
      border-radius: 4px;
      padding: 10px 40px 10px 10px;
      font-size: ${FONT_SIZE.SM};
      margin-top: 18px;
    }

    > div {
      cursor: pointer;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .validate {
    text-align: left !important;
    margin-left: 30px;
    margin-top: 10px;
    color: ${COLOR.RED_2};
    font-family: NunitoRegular;
  }

  .validate.no-errors {
    color: ${COLOR.BLACK_1};

    p {
      font-family: NunitoRegular;
      font-size: ${FONT_SIZE.XXS};
      margin-bottom: 4px;
    }

    ul {
      padding-left: 20px;
      margin-top: 16px;
    }

    li {
      font-family: NunitoRegular;
      font-size: ${FONT_SIZE.XXS};
      padding-bottom: 4px;
    }
  }

  .btn_save,
  .btn_done {
    margin-top: 20px;
    padding-left: 28px;
    padding-right: 28px;
    text-align: center;
  }

  .footer {
    font-family: NunitoSansRegular;
    font-size: 12px;
    position: absolute;
    bottom: 5%;
    width: 100%;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
  }
    
    .icon-position {
      position: absolute;
      top: 45%;
      right: 20px;
    }

  @media screen and (max-width: 414px) {
    .container {
      width: 380px;
    }

    .title {
      font-size: 29px;
    }

    .sub_title {
      font-size: 15px;
      margin-bottom: 27px !important;
    }

    .input-box {
      input {
        width: 300px;
      }
    }
  }
`